import Phaser from 'phaser'
import SizeEditor from '../editor/sizeEditor'
import Editable from './editable'

export default class Platform extends Editable {
  constructor (scene, args, doSave = true) {
    super(scene, args, 'sPl', doSave)

    this.width = args.width
    this.height = args.height

    this.image = this.scene.matter.add.image(args.x, args.y, 'white')
    // this.image.setTint(scene.colorFG)
    this.image.setTint(0)
    this.image.setSize(this.width, this.height)
    this.image.setDisplaySize(this.width, this.height)
    this.image.setIgnoreGravity(true)
    this.image.setSensor(true)
    this.image.setDepth(705)
    this.image.parentContainer = this
    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory2)

    this.colorIm = this.scene.matter.add.image(args.x, args.y, 'white')
    this.colorIm.setSize(this.width - 10, this.height - 10)
    this.colorIm.setDisplaySize(this.width - 10, this.height - 10)
    this.colorIm.setTint(scene.colorFG)
    this.colorIm.setIgnoreGravity(true)
    this.colorIm.setSensor(true)
    this.colorIm.setDepth(706)
    this.colorIm.setCollisionGroup(this.scene.collisionGroupNO_COLL)
    this.colorIm.setCollisionCategory(this.scene.collisionCatNO_COLL)

    this.screwIm = this.scene.add.image(args.x, args.y, 'images', 'screw')
    this.screwIm.setDepth(707)
    this.screwIm.setVisible(this.isMoving)
    // this.screwIm.setScale(0.7)
    this.screwIm.setTint(0x777777)

    this.addEditor(new SizeEditor(this.scene, this))

    this.nextPlatform = null

    this.addHiddenProperty('width', () => { return Math.round(this.width) })
    this.addHiddenProperty('height', () => { return Math.round(this.height) })

    this.bounceMP = args.bounceMP || 1
    this.addEditableProperty('bounceMP', (value) => { this.setBounceMP(value) }, () => { return this.bounceMP })

    this.init(args, true, true)
    this.refreshBounceImage()
  }

  init (args, canMove, showCorners = false) {
    super.init(args, canMove, showCorners)

    // this.moveComponent.slowStart = true
    this.moveComponent.waitForBounce = true
    if (this.isMoving) {
      this.moveComponent.pause()
    }
  }

  setBounceMP (value) {
    this.bounceMP = value
    this.refreshBounceImage()
  }

  refreshBounceImage () {
    if (this.bounceMP < 1) {
      this.image.setTint(0x00FFFF)
    } else if (this.bounceMP > 1) {
      this.image.setTint(0xFFFF00)
    } else {
      this.image.setTint(0)
    }
  }

  onEdit () {
    super.onEdit()

    this.screwIm.x = this.image.x
    this.screwIm.y = this.image.y

    this.colorIm.x = this.image.x
    this.colorIm.y = this.image.y
    this.colorIm.setSize(this.width - 10, this.height - 10)
    this.colorIm.setDisplaySize(this.width - 10, this.height - 10)
  }

  refreshMoving () {
    super.refreshMoving()
    this.colorIm.setTint(this.isMoving ? this.scene.colorMovers : this.scene.colorFG)
    this.screwIm.setVisible(this.isMoving)
  }

  preUpdate (time, delta) {
    super.preUpdate(time, delta)

    this.colorIm.x = this.image.x
    this.colorIm.y = this.image.y
    this.colorIm.setVelocityX(this.image.body.velocity.x)
    this.colorIm.setVelocityY(this.image.body.velocity.y)

    this.screwIm.x = this.image.x
    this.screwIm.y = this.image.y

    if (this.isMoving && !this.moveComponent.paused) {
      this.screwIm.setAngle(this.screwIm.angle + Math.sign(1 - this.moveComponent.t) * Math.sign(this.moveComponent.p1.x - this.moveComponent.p0.x) * delta * 0.5)
    }
  }

  hide () {
    this.image.setVisible(false)
    this.colorIm.setVisible(false)
    this.screwIm.setVisible(false)

    this.image.setCollisionGroup(this.scene.collisionGroupNO_COLL)
    this.image.setCollisionCategory(this.scene.collisionCatNO_COLL)
  }

  show () {
    this.image.setVisible(true)
    this.colorIm.setVisible(true)

    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory2)
  }

  delete () {
    this.colorIm.destroy()
    this.screwIm.destroy()
    super.delete()
  }
}
